<template>
  <div class="pr-side-popup-root">
    <SidePopup
      title=""
      v-on:close="onClose"
      @submit="confirmar"
      :loading="loading || saving"
      routeback="/fornecedor/comercial/programa-recompensa/saldo-pontos"
      :closeOnOutsideClick="!loading && !saving"
    >
      <template v-slot:title>
        <div class="pr-popup-title">
          <div class="pr-title-text">
            <h3 class="pr-title-main">{{ displayClientName }}</h3>
          </div>
        </div>
      </template>

      <div class="pr-body">
        <p class="pr-title-sub">
          <span class="pr-title-sub-lead">AJUSTE MANUAL DE PONTOS</span>
        </p>

        <v-divider class="mb-4" />

        <div class="pr-summary-grid pr-summary-grid--3">
          <div class="pr-card pr-card-plain">
            <div class="pr-card-label">Saldo confirmado</div>
            <div class="pr-card-value">
              {{ formatarSaldo(saldos.saldo_confirmado) }}
            </div>
          </div>
          <div class="pr-card pr-card-plain">
            <div class="pr-card-label">Saldo pendente</div>
            <div class="pr-card-value">
              {{ formatarSaldo(saldos.saldo_pendente) }}
            </div>
          </div>
          <div class="pr-card pr-card-plain">
            <div class="pr-card-label">Saldo expirado</div>
            <div class="pr-card-value">
              {{ formatarSaldo(saldos.saldo_expirado) }}
            </div>
          </div>
        </div>

        <div class="pr-section mt-6">
          <div class="pr-section-heading">
            <v-icon small color="grey darken-1" class="mr-1"
              >fas fa-sliders-h</v-icon
            >
            <span>Operação</span>
          </div>

          <v-btn-toggle
            v-model="tipoOperacao"
            mandatory
            dense
            class="pr-aba-toggle mb-4"
            :class="{ 'pr-aba-toggle--dark': darkEnabled }"
            :disabled="loading || saving"
          >
            <v-btn small value="ADICIONAR">Adicionar</v-btn>
            <v-btn small value="REMOVER">Remover</v-btn>
          </v-btn-toggle>

          <FormField
            label="Pontos"
            v-model="pontos"
            typeField="number"
            :disabled="loading || saving"
            hint="Informe um valor maior que zero."
            :persistenthint="true"
          />

          <FormText
            label="Motivo"
            v-model="motivo"
            :disabled="loading || saving"
            :rows="4"
            :maxlength="500"
          />
        </div>
      </div>

      <div v-if="error" class="pr-error">
        {{ error }}
      </div>

      <template v-slot:buttons>
        <FormButton
          text="Confirmar"
          submit
          type="submissao"
          :loading="saving"
          :disabled="loading || saving"
        />
      </template>
    </SidePopup>
  </div>
</template>

<script>
import SidePopup from "@/components/SidePopup";
import FormButton from "@/components/form/FormButton";
import FormField from "@/components/form/FormField";
import FormText from "@/components/form/FormText";
import { mapGetters } from "vuex";
import { CLIENTE_LOAD } from "@/store/actions/cliente";
import {
  PROGRAMA_RECOMPENSA_LOAD_SALDO_CLIENTE,
  PROGRAMA_RECOMPENSA_AJUSTAR_SALDO
} from "@/store/actions/programaRecompensa";

export default {
  name: "ProgramaRecompensaAjusteSaldo",
  components: {
    SidePopup,
    FormButton,
    FormField,
    FormText
  },
  data: () => ({
    loading: true,
    saving: false,
    error: "",
    clientName: "",
    saldos: {
      saldo_confirmado: "0",
      saldo_pendente: "0",
      saldo_expirado: "0"
    },
    tipoOperacao: "ADICIONAR",
    pontos: "",
    motivo: ""
  }),
  computed: {
    ...mapGetters(["getFornecedorId", "darkEnabled"]),
    idcliente() {
      return this.$route.params.idcliente;
    },
    displayClientName() {
      const raw = this.clientName || this.$route.query.clientName || "Cliente";
      return String(raw).toUpperCase();
    }
  },
  watch: {
    idcliente: {
      immediate: true,
      handler() {
        this.load();
      }
    }
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    async load() {
      this.loading = true;
      this.error = "";
      this.tipoOperacao = "ADICIONAR";
      this.pontos = "";
      this.motivo = "";
      this.saldos = {
        saldo_confirmado: "0",
        saldo_pendente: "0",
        saldo_expirado: "0"
      };

      const fid = this.getFornecedorId;
      const id = this.idcliente;
      if (!fid || !id) {
        this.loading = false;
        this.error = "Dados insuficientes para carregar o cliente.";
        return;
      }

      const queryName = (this.$route.query.clientName || "").trim();
      if (queryName) {
        this.clientName = queryName;
      } else {
        try {
          const cliente = await this.$store.dispatch(CLIENTE_LOAD, {
            idcliente: id
          });
          this.clientName =
            (cliente && (cliente.nome || cliente.email)) || "Cliente";
        } catch (_err) {
          this.clientName = "Cliente";
        }
      }

      try {
        const saldo = await this.$store.dispatch(
          PROGRAMA_RECOMPENSA_LOAD_SALDO_CLIENTE,
          { idcliente: id }
        );
        this.saldos = {
          saldo_confirmado: saldo.saldo_confirmado || "0",
          saldo_pendente: saldo.saldo_pendente || "0",
          saldo_expirado: saldo.saldo_expirado || "0"
        };
      } catch (err) {
        const msg =
          (err.response && err.response.data && err.response.data.err) ||
          err.message ||
          "Não foi possível carregar o saldo do cliente.";
        this.error = typeof msg === "string" ? msg : "Erro ao carregar saldo.";
      } finally {
        this.loading = false;
      }
    },
    validarFormulario() {
      const pontosNum = parseFloat(String(this.pontos).replace(",", "."));
      if (!Number.isFinite(pontosNum) || pontosNum <= 0) {
        return "Informe uma quantidade de pontos maior que zero.";
      }
      const motivoTrim = (this.motivo || "").trim();
      if (motivoTrim.length < 10) {
        return "O motivo deve ter pelo menos 10 caracteres.";
      }
      if (motivoTrim.length > 500) {
        return "O motivo deve ter no máximo 500 caracteres.";
      }
      return "";
    },
    async confirmar() {
      if (this.loading || this.saving) {
        return;
      }
      this.error = "";
      const validationError = this.validarFormulario();
      if (validationError) {
        this.error = validationError;
        return;
      }

      this.saving = true;
      const pontosNum = parseFloat(String(this.pontos).replace(",", "."));
      const idempotencyKey =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : undefined;

      try {
        await this.$store.dispatch(PROGRAMA_RECOMPENSA_AJUSTAR_SALDO, {
          customer_id: this.idcliente,
          tipo_operacao: this.tipoOperacao,
          pontos: pontosNum,
          motivo: this.motivo.trim(),
          idempotencyKey
        });
        this.$vueOnToast.pop("success", "Saldo ajustado com sucesso.");
        await new Promise(resolve => setTimeout(resolve, 1500));
        this.$emit("close");
        await this.$router.replace({
          path: "/fornecedor/comercial/programa-recompensa/saldo-pontos"
        });
      } catch (err) {
        const msg =
          (err.response && err.response.data && err.response.data.err) ||
          err.message ||
          "Não foi possível ajustar o saldo.";
        this.error =
          typeof msg === "string" ? msg : "Não foi possível ajustar o saldo.";
      } finally {
        this.saving = false;
      }
    },
    formatarSaldo(value) {
      if (value == null || value === "") {
        return "0";
      }
      const n = parseFloat(String(value).replace(",", "."));
      if (!Number.isFinite(n)) {
        return String(value);
      }
      return n.toLocaleString("pt-BR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pr-side-popup-root {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  z-index: 1001;
  overflow: hidden;
}

.pr-side-popup-root ::v-deep .container-popup-side {
  min-height: 100%;
  height: 100%;
}

.pr-side-popup-root ::v-deep .section-container {
  @media (min-width: 1264px) {
    width: 35% !important;
    max-width: 560px !important;
    flex-shrink: 0;
  }
}

.pr-popup-title {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-right: 8px;
}

.pr-title-main {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  line-height: 1.3;
  text-transform: uppercase;
}

.pr-title-sub {
  margin: 8px 0 0;
  font-size: 1.125rem;
  line-height: 1.45;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.65);
}

.theme--dark .pr-title-sub {
  color: rgba(255, 255, 255, 0.75);
}

.pr-title-sub-lead {
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 700;
}

.pr-error {
  color: #c62828;
  margin-bottom: 24px;
  text-align: center;
  font-size: 0.9rem;
}

.pr-body {
  padding-bottom: 16px;
}

.pr-summary-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.pr-summary-grid--3 {
  grid-template-columns: repeat(3, 1fr);
}

@media (max-width: 600px) {
  .pr-summary-grid--3 {
    grid-template-columns: 1fr;
  }
}

.pr-card {
  border-radius: 10px;
  padding: 14px 16px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
}

.theme--dark .pr-card {
  background: #1e1e1e;
  border-color: rgba(255, 255, 255, 0.12);
}

.pr-card-plain {
  background: #fafafa;
}

.theme--dark .pr-card-plain {
  background: #2a2a2a;
}

.pr-card-label {
  font-size: 0.7rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 8px;
}

.theme--dark .pr-card-label {
  color: rgba(255, 255, 255, 0.5);
}

.pr-card-value {
  font-size: 0.95rem;
  font-weight: 600;
}

.pr-section-heading {
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 12px;
  color: rgba(0, 0, 0, 0.55);
}

.theme--dark .pr-section-heading {
  color: rgba(255, 255, 255, 0.65);
}

.pr-aba-toggle {
  border-radius: 8px;
  overflow: hidden;
}

.pr-aba-toggle--dark ::v-deep .v-btn {
  border-color: rgba(255, 255, 255, 0.2) !important;
}
</style>
